import React from 'react';
import { PropTypes } from 'prop-types';
import { useFeatureFlag } from 'common/hooks';
import BackButton from './BackButton';
import RejectEnrollmentRequestButton from '../RejectEnrollmentRequestButton';
import AcceptEnrollmentRequestButton from '../AcceptEnrollmentRequestButton';
import ReviewEnrollmentRequest from '../ReviewEnrollmentRequest';
import { ENROLLMENT_STATUSES } from '../../constants';

const ActionBar = ({ enrollmentRequest }) => {
  const allowUserToMarkEnrollmentRequestInReview = useFeatureFlag('allow-user-to-mark-enrollment-request-in-review');
  const requestIsOpen = enrollmentRequest?.enrollment_status === ENROLLMENT_STATUSES.open;

  const showReviewEnrollmentRequest = allowUserToMarkEnrollmentRequestInReview && requestIsOpen;
  return (
    <div className="top-0 z-50 flex px-4 py-4 bg-white border-b border-solid border-dark-border-blue">
      <div className="flex-grow">
        <BackButton />
      </div>
      <div className="flex flex-row space-x-2">
        {
          showReviewEnrollmentRequest && (
            <ReviewEnrollmentRequest enrollmentRequest={enrollmentRequest} />
          )
        }
        <RejectEnrollmentRequestButton enrollmentRequest={enrollmentRequest} />
        <AcceptEnrollmentRequestButton
          enrollmentRequest={enrollmentRequest}
          fullViewPage
        />
      </div>
    </div>
  );
};

ActionBar.propTypes = {
  enrollmentRequest: PropTypes.object.isRequired,
};

export default ActionBar;
